/**
 * WalkAndPunch API
 * This is the WalkAndPunch Service API.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { MasterViewModel } from './masterViewModel';

export interface InspectionMediaViewModel { 
    id?: number;
    mimeType?: string;
    mediaTypeId?: number;
    file?: string;
    default?: boolean;
    name?: string;
    description?: string;
    lastModifiedAt?: Date;
    documentType?: MasterViewModel;
    defaultDownload?: boolean;
    size?: number;
}